import { PostService } from "@/services/post.service";
import { mapGetters } from "vuex";
export const postMixin = {
    data() {
        return {
            notices: [],
            reads: [],
            loading: false,
            errored: false,
            unreadCount: 0
        };
    },
    created() {
    },
    computed: {
        ...mapGetters({
            currentUser: "currentUser",
            currentAccess: "currentAccess",
        }),
        parsedNotices() {
            return this.notices //.slice(0, 3);
          },
          noticeCount() {
            return this.notices.length;
          },
    },
    methods: {
        fetchNotices() {
            PostService.getByType("notice", "public")
              .then((response) => {
                this.notices = response.data.data;
                this.fetchReads();
              })
              .catch((err) => {
                console.log("notices " + err);
                this.errored = true;
              })
              .finally(() => (this.loading = false));
          },
          fetchReads() {
            PostService.getUserReads(this.currentUser.teacherIdentifier)
              .then((response) => {
                this.reads = response.data.data
                this.parseUnreadCount()
              })
              .catch((err) => {
                console.log("reads " + err);
                this.errored = true;
              });
          },
          parseUnreadCount() {
            let vm = this;
            let posts = vm.notices.map((p) => p.identifier);
            let read = vm.reads.map((r) => r.post_identifier);
            let result = posts.reduce((a, b) => a + !read.includes(b), 0);
            this.unreadCount =  result;
          },
          processMark(posts) {
            let vm = this
            posts.forEach(function (pp, index) {
              let found = vm.reads.find((p) => {
                return p.post_identifier === pp.identifier;
              });
      
              if (found === undefined) {
                let payload = {
                  post_identifier: pp.identifier,
                  user_identifier: vm.currentUser.teacherIdentifier,
                };
                PostService.markAsRead(payload)
                  .then((response) => {
                    if (index == posts.length - 1) {
                      vm.fetchReads();
                    }
                  })
                  .catch((err) => {
                    console.log("notices " + err);
                    vm.errored = true;
                  });
              }
            });
          },
    }
};
